import { datadogRum } from "@datadog/browser-rum";

export const LOGIN_PROMO_SHOWN_ACTION = "login_promo_shown";
export const LOGIN_PROMO_SELECTED_ACTION = "login_promo_selected";

/** How a promo came on screen: the visit opened on it, the timer advanced to it, or a click. */
export type LoginPromoSource = "start" | "rotation" | "click";

/**
 * Report one promo coming on screen. Callers send this at most once per promo
 * per page load: a login tab left open overnight would otherwise send one
 * action every interval. Never thrown from — this runs on the login screen.
 */
export function trackLoginPromoShown(promo: string, source: LoginPromoSource) {
  try {
    datadogRum.addAction(LOGIN_PROMO_SHOWN_ACTION, { promo, source });
  } catch {
    // Telemetry is never worth breaking the login screen over.
  }
}

export function trackLoginPromoSelected(promo: string) {
  try {
    datadogRum.addAction(LOGIN_PROMO_SELECTED_ACTION, { promo });
  } catch {
    // Telemetry is never worth breaking the login screen over.
  }
}
